module.exports = __webpack_public_path__ + "static/media/mymyndlogo.caa86cc0.png";